var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilledHeart2 = function SvgFilledHeart2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M10.96 2.066A3.7 3.7 0 0 0 8 3.553a3.7 3.7 0 0 0-2.96-1.487c-2.046 0-3.706 1.667-3.706 3.727 0 .793.127 1.527.347 2.207 1.053 3.333 4.3 5.326 5.906 5.873.227.08.6.08.827 0 1.607-.547 4.853-2.54 5.907-5.873.22-.68.346-1.414.346-2.207 0-2.06-1.66-3.727-3.706-3.727"
  })));
};
export { SvgFilledHeart2 as ReactComponent };